import axios from 'axios';
import { Logger } from '../utils/logger';

const SSE_HEADER = 'x-amz-server-side-encryption';
const SSE_AES256 = 'AES256';

export class PutClient {
    static async put<T>(url: string, data: File): Promise<T> {
        return PutClient.upload(url, data, { [SSE_HEADER]: SSE_AES256 });
    }

    // Sends no encryption header, so S3 applies the bucket's own default encryption.
    static async putWithBucketDefaultEncryption<T>(url: string, data: File): Promise<T> {
        return PutClient.upload(url, data, {});
    }

    private static async upload<T>(url: string, data: File, encryptionHeaders: Record<string, string>): Promise<T> {
        // Send data to url
        Logger.debug(`Pushing file ${data.name} to url: ${url}`);
        const options = {
            headers: {
                ...encryptionHeaders,
                'Content-Type': data.type || 'application/octet-stream',
            },
        };
        return await axios.put(url, data, options);
    }
}
